import { createAsyncThunk } from '@reduxjs/toolkit'
import { taskTrackerApi } from '../../api/taskTracker.api'
import type { TaskTrackerFilter, TaskTrackerFilterFieldType } from '../domain.types'
import { getErrorMessage } from '../shared/thunk.utils'

export type FetchFiltersCatalogArg = { force?: boolean } | undefined

export type ReorderFilterThunkPayload = {
  activeFilterId: number
  position: number
  reorderedFilters: TaskTrackerFilter[]
  previousFilters: TaskTrackerFilter[]
}

export const fetchFiltersCatalogThunk = createAsyncThunk(
  'taskTracker/fetchFiltersCatalog',
  async (_: FetchFiltersCatalogArg, { rejectWithValue }) => {
    try {
      return await taskTrackerApi.getFilters()
    } catch (error: unknown) {
      return rejectWithValue(
        getErrorMessage(error, 'Не удалось загрузить каталог стикеров'),
      )
    }
  },
)

export const reorderFilterThunk = createAsyncThunk(
  'taskTracker/reorderFilter',
  async (payload: ReorderFilterThunkPayload, { rejectWithValue }) => {
    const movedFilter = payload.reorderedFilters.find(
      (item) => item.id === payload.activeFilterId,
    )

    if (movedFilter == null) {
      return null
    }

    try {
      const updatedFilters = await taskTrackerApi.updateFilter(movedFilter.id, {
        fieldType: movedFilter.fieldType as TaskTrackerFilterFieldType,
        title: movedFilter.title,
        color: movedFilter.color,
        isRequired: movedFilter.isRequired,
        position: payload.position,
        options: movedFilter.options,
      })
      return {
        previousFilters: payload.previousFilters,
        updatedFilters,
      }
    } catch (error: unknown) {
      return rejectWithValue({
        previousFilters: payload.previousFilters,
        error,
      })
    }
  },
)
